import { apiClient, type RequestOptions } from '@/services/apiClient';
import type { FinanceCommandCenterPayload } from './financeCommandCenter.types';
import type { FinanceInvoicePage, FinanceInvoiceQuery, FinanceInvoiceRecord, InvoiceDirection } from './financeInvoices.types';

function invoiceQuery(query: FinanceInvoiceQuery) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) if (value !== undefined && value !== '') params.set(key, String(value));
  const encoded = params.toString();
  return encoded ? `?${encoded}` : '';
}

export const financeCommandCenterApi = {
  getDashboard: (options?: RequestOptions) => apiClient.get<FinanceCommandCenterPayload>('/v1/finance/command-center', options),
  listInvoices: (direction: InvoiceDirection, query: FinanceInvoiceQuery, options?: RequestOptions) => apiClient.get<FinanceInvoicePage>(`/v1/finance/command-center/invoices/${direction}${invoiceQuery(query)}`, options),
  getInvoice: (direction: InvoiceDirection, id: string, asOf: string | undefined, options?: RequestOptions) => apiClient.get<FinanceInvoiceRecord>(`/v1/finance/command-center/invoices/${direction}/${encodeURIComponent(id)}${invoiceQuery({ asOf })}`, options),
};
